// A date selection component. Includes a date picker and arrow controls
// to change the selected date.
// @flow
import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import Tooltip from 'material-ui/Tooltip';
import * as DateUtils from '../../lib/dateUtils';
import { LeftButton, RightButton } from './DatePickerCommonButtons';

export type DateSelectionProps = {
    date: moment$Moment, // Moment date
    onChange: (date: moment$Moment) => void //Moment date
};

type State = {
    focused: string | null
};

type FocusEvent = {
    // eslint-disable-next-line
    focused: boolean
};

export default class DateSelection extends Component<
    DateSelectionProps,
    State
> {
    state: State = {
        focused: null
    };

    advanceDay = () => {
        const copy = this.props.date.clone();
        copy.add(1, 'd');

        this.dateChanged(copy);
    };

    regressDay = () => {
        const copy = this.props.date.clone();
        copy.subtract(1, 'd');

        this.dateChanged(copy);
    };

    dateChanged = (date: moment$Moment) => {
        if (this.props.onChange && DateUtils.isValidDateString(date)) {
            this.props.onChange(date);
        }
    };

    render() {
        return (
            <div style={{ marginTop: 5 }}>
                <Tooltip title="Previous Day">
                    <LeftButton
                        color="inherit"
                        aria-label="Previous Day"
                        onClick={this.regressDay}
                        className="next-prev-button"
                    />
                </Tooltip>
                <div style={{ display: 'inline-block', marginLeft: 0 }}>
                    <div style={{ fontSize: 10, margin: 0 }}>
                        Date Completed
                    </div>
                    <SingleDatePicker
                        noBorder
                        onDateChange={this.dateChanged}
                        date={this.props.date}
                        isOutsideRange={() => false}
                        focused={this.state.focused}
                        displayFormat={DateUtils.CALENDAR_FORMAT}
                        onFocusChange={({ focused }: FocusEvent) =>
                            this.setState({ focused })
                        }
                        reopenPickerOnClearDate
                        navPrev={
                            <LeftButton className="date-picker-previous" />
                        }
                        navNext={<RightButton className="date-picker-next" />}
                    />
                </div>
                <Tooltip title="Next Day">
                    <RightButton
                        color="inherit"
                        aria-label="Next Day"
                        onClick={this.advanceDay}
                        className="next-prev-button next-button"
                    />
                </Tooltip>
            </div>
        );
    }
}
